import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Role } from '@web/shared/module/auth';
import { Nillable } from '@web/utils';

@jsonObject
export class UserCreateRequest {
  @jsonMember(String)
  public readonly firstName?: Nillable<string>;

  @jsonMember(String)
  public readonly lastName?: Nillable<string>;

  @jsonMember(String)
  public readonly displayName?: Nillable<string>;

  @jsonMember(String)
  public readonly username!: string;

  @jsonMember(String)
  public readonly email!: string;

  @jsonArrayMember(String)
  public readonly roles!: Role[];

  @jsonMember(Boolean)
  public readonly newsletter!: boolean;

  @jsonMember(String)
  public readonly password?: Nillable<string>;

  public constructor(
    private readonly data: {
      firstName?: Nillable<string>;
      lastName?: Nillable<string>;
      displayName?: Nillable<string>;
      username: string;
      email: string;
      roles: Role[];
      newsletter: boolean;
      password?: Nillable<string>;
    },
  ) {
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.displayName = this.data.displayName;
    this.username = this.data.username;
    this.email = this.data.email;
    this.roles = this.data.roles;
    this.newsletter = this.data.newsletter;
    this.password = this.data.password;
  }
}
